import { Box, Paper, SvgIcon, SxProps, Theme, Typography } from "@mui/material";
import React from "react";

interface Props {
    title: string;
    icon: typeof SvgIcon;
    sx?: SxProps<Theme>;
    children: React.ReactNode;
}

export const SettingsCard = ({ title, icon: Icon, sx, children }: Props) => {
    return (
        <Paper elevation={0} sx={{ maxWidth: "md", ...sx }}>
            <Box display="flex" sx={{ py: 1 }}>
                <Icon
                    sx={{
                        display: "inline-flex",
                        mr: 1,
                        color: (theme) => theme.palette.primary.main,
                    }}
                />
                <Typography color="textSecondary" fontWeight="bold">
                    {title}
                </Typography>
            </Box>
            <Box>{children}</Box>
        </Paper>
    );
};
